export default function TrendingSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-10">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Trending Now
          </h2>
          <p className="mt-3 text-foreground-600 text-base">
            Hot items from our latest PandabuySpreadsheet updates
          </p>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-thin">
          <div className="flex-shrink-0 w-[260px] md:w-[280px]">
            <div className="rounded-2xl bg-background-100 p-5">
              <div className="relative">
                <span className="absolute top-2 left-2 z-10 px-2.5 py-1 rounded-lg bg-accent-500 text-background-50 text-[11px] font-semibold whitespace-nowrap">New</span>
                <div className="aspect-square rounded-xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=New%20Balance%20550%20grey%20suede%20sneakers%20on%20textured%20warm%20sand%20colored%20surface%20soft%20natural%20daylight%20editorial%20product%20photography%20clean%20minimal%20composition%20with%20gentle%20shadows&width=600&height=600&seq=trend-newb-2701&orientation=squarish"
                    alt="New Balance 550 Grey PandabuySpreadsheet find"
                    title="PandabuySpreadsheet New Balance 550"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 px-1">
              <p className="text-sm font-semibold text-foreground-950">New Balance 550 Grey</p>
              <p className="text-xs text-foreground-500 mt-0.5">From $35</p>
            </div>
          </div>

          <div className="flex-shrink-0 w-[260px] md:w-[280px]">
            <div className="rounded-2xl bg-background-100 p-5">
              <div className="relative">
                <span className="absolute top-2 left-2 z-10 px-2.5 py-1 rounded-lg bg-accent-500 text-background-50 text-[11px] font-semibold whitespace-nowrap">Hot</span>
                <div className="aspect-square rounded-xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Stussy%20graphic%20t-shirt%20in%20heathered%20grey%20folded%20on%20light%20oak%20wooden%20surface%20soft%20morning%20sunlight%20editorial%20product%20photography%20clean%20minimal%20aesthetic%20warm%20neutral%20tones&width=600&height=600&seq=trend-stus-2701&orientation=squarish"
                    alt="Stussy Graphic Tee PandabuySpreadsheet find"
                    title="PandabuySpreadsheet Stussy Tee"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 px-1">
              <p className="text-sm font-semibold text-foreground-950">Stussy Graphic Tee</p>
              <p className="text-xs text-foreground-500 mt-0.5">From $22</p>
            </div>
          </div>

          <div className="flex-shrink-0 w-[260px] md:w-[280px]">
            <div className="rounded-2xl bg-background-100 p-5">
              <div className="relative">
                <span className="absolute top-2 left-2 z-10 px-2.5 py-1 rounded-lg bg-accent-500 text-background-50 text-[11px] font-semibold whitespace-nowrap">Trend</span>
                <div className="aspect-square rounded-xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Arcteryx%20style%20black%20technical%20jacket%20on%20smooth%20light%20concrete%20surface%20soft%20diffused%20studio%20lighting%20editorial%20product%20photography%20clean%20industrial%20minimal%20aesthetic%20with%20subtle%20shadows&width=600&height=600&seq=trend-arc-2701&orientation=squarish"
                    alt="Technical Shell Jacket PandabuySpreadsheet find"
                    title="PandabuySpreadsheet Technical Jacket"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 px-1">
              <p className="text-sm font-semibold text-foreground-950">Technical Shell Jacket</p>
              <p className="text-xs text-foreground-500 mt-0.5">From $48</p>
            </div>
          </div>

          <div className="flex-shrink-0 w-[260px] md:w-[280px]">
            <div className="rounded-2xl bg-background-100 p-5">
              <div className="relative">
                <div className="aspect-square rounded-xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chrome%20Hearts%20style%20cargo%20pants%20in%20olive%20green%20on%20textured%20warm%20terracotta%20surface%20natural%20daylight%20editorial%20product%20photography%20minimal%20composition%20with%20interesting%20fabric%20details%20visible&width=600&height=600&seq=trend-carg-2701&orientation=squarish"
                    alt="Olive Cargo Pants PandabuySpreadsheet find"
                    title="PandabuySpreadsheet Cargo Pants"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 px-1">
              <p className="text-sm font-semibold text-foreground-950">Heavyweight Cargo Pants</p>
              <p className="text-xs text-foreground-500 mt-0.5">From $38</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}